<template>
  <div class="main-wrapper">

    <div class="main-scroll">
      <Navs></Navs>
      <person-center></person-center>
      <Foots class="foots"></Foots>
    </div>
    <bottom-backtop></bottom-backtop>

  </div>
</template>
<script>
import Navs from '../common/navs';
import Foots from '../common/foots';
import PersonCenter from './personcenter';
import BottomBacktop from '../common/BottomBacktop';

export default {
  components: {
    Navs,
    Foots,
    PersonCenter,
    BottomBacktop
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style lang="scss" scoped>

</style>
